import Icon from '@mui/material/Icon';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import {
  HiArrowRightOnRectangle,
  HiMiniArrowUpOnSquare,
  HiOutlineArchiveBox,
  HiOutlineArrowDownTray,
  HiOutlineArrowLongLeft,
  HiOutlineArrowRightOnRectangle,
  HiOutlineArrowSmallLeft,
  HiOutlineArrowSmallRight,
  HiOutlineArrowsPointingOut,
  HiOutlineArrowUturnLeft,
  HiOutlineBars3,
  HiOutlineBars3BottomLeft,
  HiOutlineBriefcase,
  HiOutlineBuildingOffice,
  HiOutlineBuildingOffice2,
  HiOutlineCake,
  HiOutlineCalendarDays,
  HiOutlineChartPie,
  HiOutlineChatBubbleLeftEllipsis,
  HiOutlineChatBubbleLeftRight,
  HiOutlineCheck,
  HiOutlineCheckCircle,
  HiOutlineChevronDown,
  HiOutlineChevronRight,
  HiOutlineClipboardDocumentList,
  HiOutlineClock,
  HiOutlineCog6Tooth,
  HiOutlineSquares2X2 as HiOutlineCollection,
  HiOutlineDocument,
  HiOutlineDocumentArrowDown,
  HiOutlineDocumentArrowUp,
  HiOutlineDocumentChartBar,
  HiOutlineDocumentCheck,
  HiOutlineDocumentPlus,
  HiOutlineDocumentText,
  HiOutlineEllipsisVertical,
  HiOutlineEnvelope,
  HiOutlineExclamationCircle,
  HiOutlineInbox,
  HiSun,
} from 'react-icons/hi2';

import { IoSettingsOutline, IoLinkOutline, IoLocationOutline, IoSaveOutline } from 'react-icons/io5';

import { FaRegCopy, FaClockRotateLeft, FaSuitcaseMedical, FaPlaneDeparture } from 'react-icons/fa6';

import { PiIslandFill, PiTreePalm, PiUsersThree } from 'react-icons/pi';

import { HiOutlineTemplate } from 'react-icons/hi';

import { BiCalendarStar } from 'react-icons/bi';
import {
  HiOutlineEye,
  HiOutlineFlag,
  HiOutlineFolder,
  HiOutlineGlobeAlt,
  HiOutlineHome,
  HiOutlineIdentification,
  HiOutlineInformationCircle,
  HiOutlineLink,
  HiOutlineListBullet,
  HiOutlineMagnifyingGlass,
  HiOutlineMap,
  HiOutlineMapPin,
  HiOutlinePaperAirplane,
  HiOutlinePaperClip,
  HiOutlinePencil,
  HiOutlinePhone,
  HiOutlinePlus,
  HiOutlinePlusCircle,
  HiOutlinePresentationChartBar,
  HiOutlineQuestionMarkCircle,
  HiOutlineScale,
  HiOutlineShieldCheck,
  HiOutlineTableCells,
  HiOutlineTag,
  HiOutlineTrash,
  HiOutlineUser,
  HiOutlineUserCircle,
  HiOutlineUserGroup,
  HiOutlineUserPlus,
  HiOutlineUsers,
  HiOutlineVideoCamera,
  HiOutlineViewColumns,
  HiOutlineXMark,
} from 'react-icons/hi2';
import { MdAutoAwesome, MdAutoFixHigh, MdFindInPage, MdGrading } from 'react-icons/md';
import { FaRegCalendarAlt, FaUsers } from 'react-icons/fa';

const ICONS_MAP = {
  'react-outline:building-office-2': HiOutlineBuildingOffice2,
  'react-outline:collection': HiOutlineCollection,
  'react-outline:user-group': HiOutlineUserGroup,
  'react-outline:chat-alt': HiOutlineChatBubbleLeftRight,
  'react-outline:video-camera': HiOutlineVideoCamera,
  'react-outline:home': HiOutlineHome,
  'react-outline:view-boards': HiOutlineViewColumns,
  'react-outline:users': HiOutlineUsers,
  'react-outline:clipboard': HiOutlineClipboardDocumentList,
  'react-outline:flag': HiOutlineFlag,
  'react-outline:document-check': HiOutlineDocumentCheck,
  'react-outline:map': HiOutlineMap,
  'react-outline:document-text': HiOutlineDocumentText,
  'react-outline:folder': HiOutlineFolder,
  'react-outline:briefcase': HiOutlineBriefcase,
  'react-outline:calendar': HiOutlineCalendarDays,
  'react-outline:globe-alt': HiOutlineGlobeAlt,
  'react-outline:question-mark-circle': HiOutlineQuestionMarkCircle,
  'react-outline:phone': HiOutlinePhone,
  'react-outline:archive-box-arrow-down': HiOutlineArrowDownTray,
  'react-outline:presentation-chart-bar': HiOutlinePresentationChartBar,
  'react-outline:user-circle': HiOutlineUserCircle,
  'react-outline:clock': HiOutlineClock,
  'react-outline:scale': HiOutlineScale,
  'react-outline:document-chart-bar': HiOutlineDocumentChartBar,
  'react-outline:shield-check': HiOutlineShieldCheck,
  'react-outline:cog': HiOutlineCog6Tooth,
  'react-outline:chart-pie': HiOutlineChartPie,
  'react-outline:view-list': HiOutlineBars3,
  'react-outline:table': HiOutlineTableCells,
  'react-outline:user': HiOutlineUser,
  'react-outline:document-arrow-down': HiOutlineDocumentArrowDown,
  'react-outline:document': HiOutlineDocument,
  'react-outline:arrows-expand': HiOutlineArrowsPointingOut,
  'react-outline:dots-vertical': HiOutlineEllipsisVertical,
  'react-outline:list-bullet': HiOutlineListBullet,
  'react-outline:mail': HiOutlineEnvelope,
  'react-outline:paper-clip': HiOutlinePaperClip,
  'react-outline:paper-airplane': HiOutlinePaperAirplane,
  'react-outline:x': HiOutlineXMark,
  'react-outline:plus': HiOutlinePlus,
  'react-outline:trash': HiOutlineTrash,
  'react-outline:user-add': HiOutlineUserPlus,
  'react-outline:office-building': HiOutlineBuildingOffice,
  'react-outline:identification': HiOutlineIdentification,
  'react-outline:cake': HiOutlineCake,
  'react-outline:chat': HiOutlineChatBubbleLeftEllipsis,
  'react-outline:information-circle': HiOutlineInformationCircle,
  'react-outline:search': HiOutlineMagnifyingGlass,
  'react-outline:link': HiOutlineLink,
  'react-outline:arrow-sm-right': HiOutlineArrowSmallRight,
  'react-outline:arrow-sm-left': HiOutlineArrowSmallLeft,
  'react-outline:reply': HiOutlineArrowUturnLeft,
  'react-outline:arrow-narrow-left': HiOutlineArrowLongLeft,
  'react-outline:map-pin': HiOutlineMapPin,
  'react-outline:plus-circle': HiOutlinePlusCircle,
  'react-outline:check': HiOutlineCheck,
  'react-outline:chevron-down': HiOutlineChevronDown,
  'react-outline:check-circle': HiOutlineCheckCircle,
  'react-outline:pencil': HiOutlinePencil,
  'react-outline:tag': HiOutlineTag,
  'react-outline:chevron-right': HiOutlineChevronRight,
  'react-outline:eye': HiOutlineEye,
  'react-outline:menu-alt-3': HiOutlineBars3BottomLeft,
  'react-outline:exclamation-circle': HiOutlineExclamationCircle,
  'react-outline:logout': HiOutlineArrowRightOnRectangle,
  'react-outline:arrow-right-start-on-rectangle': HiArrowRightOnRectangle,
  'react-outline:incoming-doc': HiOutlineInbox,
  'react-outline:outgoing-doc': HiMiniArrowUpOnSquare,
  'react-outline:archive': HiOutlineArchiveBox,
  'react-outline:work-trip': FaPlaneDeparture,
  'react-outline:tropic': PiIslandFill,


  'react-solid:chevron-right': HiOutlineChevronRight,
  'react-solid:chevron-down': HiOutlineChevronDown,

  'material-outline:auto_awesome': MdAutoAwesome,
  'material-outline:auto_fix_high': MdAutoFixHigh,
  'material-outline:grading': MdGrading,
  'material-outline:find_in_page': MdFindInPage,
  'material-outline:save': HiOutlineArrowDownTray,
  'react-icons:bi-calendar-star': BiCalendarStar,

  'react-outline:settings': IoSettingsOutline,
  'react-outline:link-outline': IoLinkOutline,
  'react-outline:location-outline': IoLocationOutline,
  'react-outline:document-plus': HiOutlineDocumentPlus,
  'react-outline:incoming-document': HiOutlineDocumentArrowDown,
  'react-outline:outgoing-document': HiOutlineDocumentArrowUp,
  'react-outline:templates-management': HiOutlineTemplate,
  'react-outline:save': IoSaveOutline,
  'react-outline:palm-tree': PiTreePalm,
  'react-outline:sun': HiSun,
  'react-outline:medicine': FaSuitcaseMedical,
  'react-outline:save': IoSaveOutline,

  'react-icons:fa-regular-calendar-alt': FaRegCalendarAlt,
  'react-icons:fa-regular-users': FaUsers,

  'react-icons:fa6-regular-copy': FaRegCopy,
  'react-icons:fa6-regular-clock-rotate-left': FaClockRotateLeft,

  'react-icons:pi-users-three': PiUsersThree,
};

const Root = styled(Box)(({ theme, ...props }) => ({
  width: props.size,
  height: props.size,
  minWidth: props.size,
  minHeight: props.size,
  fontSize: props.size,
  lineHeight: props.size,
  color: {
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    info: theme.palette.info.main,
    success: theme.palette.success.main,
    warning: theme.palette.warning.main,
    action: theme.palette.action.active,
    error: theme.palette.error.main,
    disabled: theme.palette.action.disabled,
    inherit: undefined,
  }[props.color],
}));

const FuseSvgIcon = forwardRef((props, ref) => {
  const { children = '', size = 24, className, sx, color, ...rest } = props;

  if (!children.includes(':')) {
    return (
      <Icon ref={ref} {...rest} className={className} sx={sx} color={color} fontSize="inherit">
        {children}
      </Icon>
    );
  }

  const IconComp = ICONS_MAP[children];

  if (IconComp) {
    return (
      <Root
        {...rest}
        ref={ref}
        component="span"
        size={size}
        sx={sx}
        color={color}
        className={clsx('shrink-0', className)}
      >
        <IconComp size={size} />
      </Root>
    );
  }
  return null;
});

FuseSvgIcon.propTypes = {
  children: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sx: PropTypes.object,
  color: PropTypes.oneOf([
    'inherit',
    'disabled',
    'primary',
    'secondary',
    'action',
    'error',
    'info',
    'success',
    'warning',
  ]),
};

FuseSvgIcon.defaultProps = {
  children: '',
  size: 24,
  sx: {},
  color: 'inherit',
};

export default FuseSvgIcon;
